import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AddAgentRequest} from '../../_models';
import {Observable} from 'rxjs';
import {AgentResponse} from '../../_models/customers/agent/AgentResponse';
import {UserApplicationResponse} from '../../_models/users/UserApplicationResponse';
import {SearchUserAppRequest} from '../../_models/users/SearchUserAppRequest';
import {ResetPassword} from '../../_models/users/ResetPassword';
import {MailRequest} from '../../_models/users/MailRequest';
import {UserRequest} from '../../_models/users/UserRequest';
import {SearchUserByCompany} from '../../_models/users/SearchUserByCompany';
import {AgentType} from "../../_models/customers/agent/AgentType";
import {SearchUserAppResponse} from "../../_models/users/SearchUserAppResponse";
import { EnvService } from '../../_services/configurations/env.service';

@Injectable({providedIn: 'root'})
export class AgentService {

  private environment = inject(EnvService);
  private apiURL = this.environment?.readConfig()?.apiUrl;
  constructor(private http: HttpClient) {
  }

  getAllCommercial(): Observable<AgentResponse[]> {
    return this.http.get<AgentResponse[]>(`${this.apiURL}/agent/listCommercial`);
  }

  getProfilExterne(): Observable<Record<string, AgentType>> {
    return this.http.get<Record<string, AgentType>>(`${this.apiURL}/agent/profil/externe`);
  }

  getProfilInterne(): Observable<Record<string, AgentType>> {
    return this.http.get<any>(`${this.apiURL}/agent/profil/interne`);
  }

  getAllBuyer(): Observable<AgentResponse> {
    return this.http.get<AgentResponse>(`${this.apiURL}/agent/listAcheteur`);
  }

  getBuyerBySiren(siren: string): Observable<AgentResponse[]> {
    return this.http.get<AgentResponse[]>(`${this.apiURL}/agent/listAcheteurBySiren/${siren}`);
  }

  addInternalAgent(addAgentRequest: AddAgentRequest): Observable<any> {
    return this.http.post<any>(`${this.apiURL}/agent/intern/add`, addAgentRequest, {withCredentials: true});
  }

  addExternalAgent(addAgentRequest: AddAgentRequest): Observable<any> {
    return this.http.post<any>(`${this.apiURL}/agent/extern/add`, addAgentRequest, {withCredentials: true});
  }

   getSalesAdmins(): Observable<AgentResponse[]> {
      return this.http.get<AgentResponse[]>(`${this.apiURL}/agent/list/salesadmin`);
   }

  /*
    addAgent(addAgentRequest: AddAgentRequest): Observable<any>  {
      return this.http.post<any>(`${this.apiURL}/agent/adAgent`, addAgentRequest, { withCredentials: true });
    }
    addUser(addUserRequest: AddUserRequest): Observable<any>  {
      return this.http.post<any>(`${this.apiURL}/agent/user/add`, addUserRequest, { withCredentials: true });
    }
    */

  getInternalAccountsByEmail(searchUserAppRequest: SearchUserAppRequest): Observable<SearchUserAppResponse> {
    return this.http.post<SearchUserAppResponse>(`${this.apiURL}/agent/intern/search`, searchUserAppRequest, {withCredentials: true});
  }


  downloadCSVFile(userApplicationResponse: UserApplicationResponse[]): Observable<any> {
    return this.http.post(`${this.apiURL}/agent/extract/csv`, userApplicationResponse, {responseType: 'text'});
  }

  getExternalAccountsByEmail(searchUserAppRequest: SearchUserAppRequest): Observable<SearchUserAppResponse> {
    return this.http.post<SearchUserAppResponse>(`${this.apiURL}/agent/extern/search`, searchUserAppRequest, {withCredentials: true});
  }

  deleteAccount(email: string): Observable<any> {
    return this.http.get<any>(`${this.apiURL}/agent/deleteAccount/${email}`);
  }

  resetPassword(resetPassword: ResetPassword): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiURL}/agent/resetPassword`, resetPassword, {withCredentials: true});
  }

  sendMail(mailRequest: MailRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiURL}/agent/sendMail`, mailRequest, {withCredentials: true});
  }

  sendMailInternalAccount(mailRequest: MailRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiURL}/agent/mailInternalAccount`, mailRequest, {withCredentials: true});
  }

  mailResetPassword(mailRequest: MailRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiURL}/agent/mailResetPassword`, mailRequest, {withCredentials: true});
  }

  editInternalAgent(userRequest: UserRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiURL}/agent/intern/edit`, userRequest, {withCredentials: true});
  }

  editExternalAgent(userRequest: UserRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiURL}/agent/extern/edit`, userRequest, {withCredentials: true});
  }

  getAccountByClientName(searchUserByCompany: SearchUserByCompany): Observable<SearchUserAppResponse> {
    return this.http.post<SearchUserAppResponse>(`${this.apiURL}/agent/search/client`, searchUserByCompany, {withCredentials: true});
  }
}
